export type FontStyles = typeof fontStyles;

const pxToRemDict = {
  10: '0.625rem',
  11: '0.6875rem',
  12: '0.75rem',
  13: '0.8125rem',
  14: '0.875rem',
  16: '1rem',
  18: '1.125rem',
  20: '1.25rem',
  22: '1.375rem',
  28: '1.75rem',
} as const;

export const fontStyles = {
  px11_12: {
    fontSize: pxToRemDict[11],
    lineHeight: pxToRemDict[12],
  },
  px12_16: {
    fontSize: pxToRemDict[12],
    lineHeight: pxToRemDict[16],
  },
  px12_18: {
    fontSize: pxToRemDict[12],
    lineHeight: pxToRemDict[18],
  },
  px14_20: {
    fontSize: pxToRemDict[14],
    lineHeight: pxToRemDict[20],
  },
  px16_20: {
    fontSize: pxToRemDict[16],
    lineHeight: pxToRemDict[20],
  },
  px18_22: {
    fontSize: pxToRemDict[18],
    lineHeight: pxToRemDict[22],
  },
  px20_28: {
    fontSize: pxToRemDict[20],
    lineHeight: pxToRemDict[28],
  },
} as const;
